module.exports = {
  message: {
    // 首页
    navigator_website: "官網",
    navigator_collect: "收藏",
    navigator_service: "客服",
    navigator_teach: "使用教程",
    navigator_logout: "登出",
    navigator_mobile_logout: "手機號登錄",
    navigator_email_logout: "郵箱登錄",
    navigator_download: "下載",
    // 登录、注册页
    navigator_signIn: "註冊",
    navigator_lang: "登錄",
    navigator_email: "郵箱",
    input_account: "請輸入帳號",
    input_mobile: "請輸入手機號碼",
    input_password: "請輸入密碼",
    input_password_again: "請再次輸入密碼",
    input_email_address: "請輸入郵箱帳號",
    input_reset_email: "請輸入需要重置密碼的帳號或郵箱",
    input_reset_password: "，請通過以下方式驗證後重新設置密碼 ",
    retrieve_password: "找回密碼",
    forget_password: "忘記密碼",
    next_step: "下一步",
    bind_email: "綁定郵箱",
    input_bind_email: "請輸入綁定郵箱帳號",
    bound_email: "已綁定郵箱",
    enter_code: "請輸入驗證碼",
    get_code: " 讀取驗證碼 ",
    get_code_seconds: "s",
    security_verification: "安全驗證",
    inputTheAnswer: "請輸入圖中驗證碼",
    noneSelectArea: "請選擇手機號碼所在區號",
    confirm: "確定",
    bind: "绑定",
    agree: "閱讀並同意",
    tips_1: "未註冊的手機號碼沿著後將自動註冊並登錄",
    copy_success: "複製成功！",
    copy_fail: "請手動複製",
    incorrect_email: "請輸入正確的郵箱格式！",
    emailTips1: "密碼不能包含空格或者中文字符！",
    emailTips2: "請輸入至少6位密碼",
    emailTips3: "兩次密碼不相等",
    emailTips4: "驗證碼錯誤",
    emailTips5: "請輸入4-12位以字母和數字組合的帳號名",
    emailTips6: "請輸入6~20位字母數字非中文特殊字符組合的密碼",
    emailTips7: "兩次密碼不一致",
    selectAreaCode: "選擇區號",
    urlError: "當前訪問地址錯誤！",
    tips: "温馨提示",
    verifiedTips1: "您必須年滿18歲才能登入此遊戲",
    verifiedTips2: "登入失敗，需完成實名認證后可體驗游戲",
    // 底部
    rules_clause: "運營條款",
    privacy_clause: "隱私條款",
    service_email: "客服信箱：",
    EmailAddress: "maplestoryr.sea@gmail.com",
    // 教程页
    infoTitle: "PC端登錄及儲值教程",
  },
};
